import './data-mapping-page.css';
import { Button, Modal, notification } from "antd";
import { TdiNodeModel } from "../../model/tdi-node-model";
import { useEffect, useState } from "react";
import { useGetOutputPreviewMutation } from "../../redux/api/data";
import { Client } from "../../model/client-model";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs";

interface PreviewProps {
    client?: Client | undefined,
    open: boolean,
    node?: TdiNodeModel,
    onCancel: (values: any) => void
}

export const PreviewModal: React.FC<PreviewProps> = ({client, open, onCancel}): JSX.Element => {

    const [source, setSource] = useState<string>('');
    const [output, setOutput] = useState<string>('');
    
    const [previewOutput] = useGetOutputPreviewMutation();
    
    useEffect(() => {
    }, []);

    const updateSource = (e: any) => {
        setSource(e.currentTarget.value);
    }

    const preview = async () => {
        try {
            const response = await previewOutput({clientId: client?.id, data: source}).unwrap();
            setOutput(response);
        } catch (e) {
            setOutput('');
            notification.error({
            message: "Preview Failed!",
            description: `Failed to convert source data into target output.`
            });
        }
    }

    return (<Modal
        title={'Output Preview'}
        closable={true}
        open={open}
        onCancel={onCancel}
        destroyOnClose={true}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={1040}>
        <div className="preview-container">
            <div className="outpreview-container">
                <div className="content-container">
                    <div className="source-container">
                        <label>Source</label>
                        <div className="area-container">
                            <Editor
                                value={source}
                                onValueChange={source => setSource(source)}
                                highlight={(code) => highlight(code, languages.js!, 'js')}
                                padding={10}
                                style={{
                                    minHeight: '25rem',
                                    background: 'white',
                                    border: 'none',
                                    fontFamily: '"Fira code", "Fira Mono", monospace',
                                    fontSize: 14,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="content-container">
                    <div className="source-container">
                        <label>Output</label>
                        <div className="area-container">
                            <Editor
                                value={output}
                                onValueChange={output => setOutput(output)}
                                highlight={(output) => highlight(output, languages.xml!, 'xml')}
                                padding={10}
                                style={{
                                    minHeight: '25rem',
                                    background: 'white',
                                    border: 'none',
                                    fontFamily: '"Fira code", "Fira Mono", monospace',
                                    fontSize: 14,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="preview-button-container">
                <Button type="primary" 
                    onClick={preview} 
                    disabled={null == source}>
                    Preview Output
                </Button>
            </div>
        </div>
    </Modal>)
}
